module.exports = __webpack_public_path__ + "img/background.ec1932e6.png";